import { Effect } from "../Materials/effect";
var name = 'ssaoCombinePixelShader';
var shader = "uniform sampler2D textureSampler;\nuniform sampler2D originalColor;\nuniform vec4 viewport;\nvarying vec2 vUV;\nvoid main(void) {\nvec4 ssaoColor=texture2D(textureSampler,viewport.xy+vUV*viewport.zw);\nvec4 sceneColor=texture2D(originalColor,vUV);\ngl_FragColor=sceneColor*ssaoColor;\n}\n";
Effect.ShadersStore[name] = shader;
/** @hidden */
export var ssaoCombinePixelShader = { name: name, shader: shader };
//# sourceMappingURL=ssaoCombine.fragment.js.map